// extracted by mini-css-extract-plugin
module.exports = {"marker":"Marker-module--marker--3c8u5","box":"Marker-module--box--2Q0sW","close":"Marker-module--close--26xHl"};